import { render, staticRenderFns } from "./numbers-badge-status.vue?vue&type=template&id=af80c210&"
import script from "./numbers-badge-status.vue?vue&type=script&lang=js&"
export * from "./numbers-badge-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports